// extracted by mini-css-extract-plugin
module.exports = {"container":"PropertyCardList_container__1dogk"};